export default {
  fontPrimary: 'golos-regular',
  fontPrimaryBold: 'golos-bold',
  colorPrimary: '#6a5acd',
  colorPrimaryDark: '#483d8b',
  colorSecondary: "#d35d5d",
  colorSecondaryDark: "#933f3f",
  colorDark: '#1a1a1a',
  colorWhite: '#fAf9f6',
  colorRed: '#8b0000',
  fontXxl: 80,
  fontXlll: 60,
  fontXll: 50,
  fontXl: 40,
  fontLgg: 34,
  fontLg: 28,
  fontMd: 20,
  fontSm: 16,
  fontXs: 12,
  fontXxs: 8
}
